import { memo } from "react";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { FormattedMessage } from "react-intl";
import "./ProductActionButtonMobile.scss";

const ProductActionButtonMobile = () => {
	return (
		<div className="product-action-button-mobile">
			<RelativeLink variant="primary" to={{ pathname: "/booking/search" }}>
				<FormattedMessage id="product.page.button.cta" />
			</RelativeLink>
		</div>
	);
};

export default memo(ProductActionButtonMobile);
